import { GetterTree } from 'vuex';
import IRootState from '@/store/types/IRootState';
import IAboutState from './types/IAboutState';

const getters: GetterTree<IAboutState, IRootState> = {
  meta: (state) => state.meta,
  header: (state) => state.header,
  sections: (state) => state.sections,
};

export default getters;
